"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgWalletOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M18 6.516V4.001a2 2 0 00-2.428-1.954l-12 2.625A2 2 0 002 6.626v12.89a2 2 0 002 2h14a2 2 0 002-2v-2.337a3.5 3.5 0 000-6.326V8.516a2 2 0 00-2-2zm-2-2.515v2.515H5.427c-.12 0-.138-.172-.022-.198L16 4.001zM4 8.516h14v2h-1.5a3.5 3.5 0 100 7H18v2H4v-11zm14.5 4h-2a1.5 1.5 0 000 3h2a1.5 1.5 0 000-3z' }))); };
exports.default = SvgWalletOutline;
//# sourceMappingURL=WalletOutline.js.map